
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "data-privacy-request-ui",
  currentProjectVersion: "static-1.6023",
  depVersions: {
  "data-privacy-request-ui": "static-1.6023",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10135",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8535",
  "hub-http-shared-msw-handlers": "static-1.10937",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11983",
  "I18n": "static-7.1714",
  "jasmine-runner": "static-1.6949",
  "quartz": "static-1.7692",
  "react-dlb": "static-1.96",
  "rpc-client-utils": "static-1.5164",
  "ui-components-test-utils": "static-1.6120",
  "UIComponents": "static-3.8929",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.101",
  "foundations-assets": "static-1.5385",
  "foundations-components": "static-1.8781",
  "foundations-components-test-utils": "static-1.6264",
  "foundations-theming": "static-1.4986",
  "hub-http": "static-1.6702",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1470",
  "quartz-core": "static-1.6911",
  "quartz-routing": "static-1.1122",
  "quartz-tracking": "static-1.1071",
  "quick-fetch": "static-1.4242",
  "raven": "static-3.6411",
  "react": "static-7.204",
  "react-rhumb": "static-1.17237",
  "SharedI18nStrings": "static-1.190",
  "ui-addon-i18n": "static-1.11642",
  "usage-tracker-core": "static-1.7670",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3969",
  "quartz-webpack": "static-1.3916",
  "bend-plugin-quartz-routing": "static-1.770",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.95",
  "HeadJS": "static-2.828",
  "framer-motion": "static-1.86",
  "hs-test-utils-bend-plugin": "static-1.3646",
  "msw": "static-1.105",
  "msw-config": "static-1.34",
  "testing-library": "static-1.167",
  "ts-schema": "static-1.4406",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "react-utils": "static-2.5675",
  "StyleGuideUI": "static-3.520",
  "jasmine": "static-4.4802",
  "bend-plugin-chirp-manifest": "static-1.574",
  "chirp-fetch": "static-1.2401",
  "HubStyle": "static-2.12290",
  "ui-addon-draggable": "static-3.5247",
  "cssUtils": "static-1.1119",
  "hs-story-utils": "static-1.9925",
  "icons": "static-2.708",
  "react-create-root-preference": "static-1.110",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "ui-images": "static-2.1282",
  "bend-plugin-foundations-components": "static-1.5050",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2702",
  "react-aria": "static-1.79",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3144",
  "ui-fonts": "static-1.1245",
  "foundations-components-legacy": "static-1.1806",
  "bend-plugin-foundations-theming": "static-1.3469",
  "foundations-theming-base": "static-1.3971",
  "stylex": "static-1.48",
  "hs-locale-management": "static-1.413",
  "opentelemetry-fe-types": "static-1.288",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.912",
  "hubspotter-http": "static-1.4986",
  "mobile-manifest-mixins": "static-1.611",
  "module-federation": "static-1.41",
  "opentelemetry-fe": "static-1.663",
  "quartz-auth": "static-1.1367",
  "quartz-head": "static-1.1357",
  "quartz-i18n": "static-1.1367",
  "quartz-test": "static-1.1367",
  "trellis-components": "static-1.3163",
  "usage-tracker-container": "static-1.7810",
  "usage-tracker-session-replay": "static-1.5506",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.196",
  "web-vitals": "static-1.21",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3613",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.85",
  "sassPrefix": "static-1.384",
  "stylex-utils": "static-1.181",
  "trellis-theming": "static-1.1513",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10935",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.6023",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10135",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8535",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10937",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11983",
  "I18n": "/I18n/static-7.1714",
  "jasmine-runner": "/jasmine-runner/static-1.6949",
  "quartz": "/quartz/static-1.7692",
  "react-dlb": "/react-dlb/static-1.96",
  "rpc-client-utils": "/rpc-client-utils/static-1.5164",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6120",
  "UIComponents": "/UIComponents/static-3.8929",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.101",
  "foundations-assets": "/foundations-assets/static-1.5385",
  "foundations-components": "/foundations-components/static-1.8781",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6264",
  "foundations-theming": "/foundations-theming/static-1.4986",
  "hub-http": "/hub-http/static-1.6702",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1470",
  "quartz-core": "/quartz-core/static-1.6911",
  "quartz-routing": "/quartz-routing/static-1.1122",
  "quartz-tracking": "/quartz-tracking/static-1.1071",
  "quick-fetch": "/quick-fetch/static-1.4242",
  "raven": "/raven/static-3.6411",
  "react": "/react/static-7.204",
  "react-rhumb": "/react-rhumb/static-1.17237",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11642",
  "usage-tracker-core": "/usage-tracker-core/static-1.7670",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3969",
  "quartz-webpack": "/quartz-webpack/static-1.3916",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.770",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.95",
  "HeadJS": "/HeadJS/static-2.828",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3646",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.34",
  "testing-library": "/testing-library/static-1.167",
  "ts-schema": "/ts-schema/static-1.4406",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "react-utils": "/react-utils/static-2.5675",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "jasmine": "/jasmine/static-4.4802",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.574",
  "chirp-fetch": "/chirp-fetch/static-1.2401",
  "HubStyle": "/HubStyle/static-2.12290",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5247",
  "cssUtils": "/cssUtils/static-1.1119",
  "hs-story-utils": "/hs-story-utils/static-1.9925",
  "icons": "/icons/static-2.708",
  "react-create-root-preference": "/react-create-root-preference/static-1.110",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "ui-images": "/ui-images/static-2.1282",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5050",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2702",
  "react-aria": "/react-aria/static-1.79",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3144",
  "ui-fonts": "/ui-fonts/static-1.1245",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1806",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3469",
  "foundations-theming-base": "/foundations-theming-base/static-1.3971",
  "stylex": "/stylex/static-1.48",
  "hs-locale-management": "/hs-locale-management/static-1.413",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.288",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.912",
  "hubspotter-http": "/hubspotter-http/static-1.4986",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.611",
  "module-federation": "/module-federation/static-1.41",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.663",
  "quartz-auth": "/quartz-auth/static-1.1367",
  "quartz-head": "/quartz-head/static-1.1357",
  "quartz-i18n": "/quartz-i18n/static-1.1367",
  "quartz-test": "/quartz-test/static-1.1367",
  "trellis-components": "/trellis-components/static-1.3163",
  "usage-tracker-container": "/usage-tracker-container/static-1.7810",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5506",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.196",
  "web-vitals": "/web-vitals/static-1.21",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3613",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.85",
  "sassPrefix": "/sassPrefix/static-1.384",
  "stylex-utils": "/stylex-utils/static-1.181",
  "trellis-theming": "/trellis-theming/static-1.1513",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10935",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
